import { athletes, grants, latestResults, mediaItems, pageCopyDefaults, partners } from "@/lib/site-data";
import type { ContentRecord } from "@/lib/content-types";

export function getDefaultContentRecords(): ContentRecord[] {
  const pageRecords = Object.entries(pageCopyDefaults).map(([slug, item], index) => ({
    id: `page-${slug}`,
    kind: "page" as const,
    title: item.title,
    status: "published" as const,
    sortOrder: index,
    data: { slug, eyebrow: item.eyebrow, description: item.description, body: item.body },
    isDefault: true,
  }));

  return [
    ...latestResults.map((item, index) => ({
      id: item.id,
      kind: "result" as const,
      title: item.title,
      status: "published" as const,
      sortOrder: index,
      data: { date: item.date, place: item.place, lead: item.lead, results: [...item.results], featured: item.featured ?? false },
      isDefault: true,
    })),
    ...athletes.map((item, index) => ({
      id: item.id,
      kind: "athlete" as const,
      title: item.name,
      status: "published" as const,
      sortOrder: index,
      data: { initials: item.initials, category: item.category, focus: item.focus, color: item.color, highlights: [...item.highlights], image: "", alt: "" },
      isDefault: true,
    })),
    ...mediaItems.map((item, index) => ({
      id: item.id,
      kind: "media" as const,
      title: item.title,
      status: "published" as const,
      sortOrder: index,
      data: { ...item },
      isDefault: true,
    })),
    ...partners.map((item, index) => ({
      id: item.id,
      kind: "partner" as const,
      title: item.name,
      status: "published" as const,
      sortOrder: index,
      data: { mark: item.mark, role: item.role, website: "", image: "", alt: `${item.name} logója` },
      isDefault: true,
    })),
    ...grants.map((item, index) => ({
      id: item.id,
      kind: "grant" as const,
      title: item.title,
      status: "published" as const,
      sortOrder: index,
      data: { badge: item.badge, reference: item.reference, goal: item.goal, areas: [...item.areas], website: "" },
      isDefault: true,
    })),
    ...pageRecords,
  ];
}
